export const getQueryParams = (params: Record<string, any>) => {
	return Object.keys(params)
		.map(k => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
		.join("&");
};
